import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import copyToClipboard from '../utils/copyToClipboard';
import generateShareLink from '../utils/shareLink';
import { useApi } from '../context/ApiProvider';

const ShareModal = ({
  open,
  onCloseModal,
  setId,
  setMessage,
  trackId,
  trackMessage,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const api = useApi();
  const [isGenerating, setIsGenerating] = useState(false);

  async function onShareTrack() {
    setIsGenerating(true);
    const trackLink = await generateShareLink('track', trackId, api);
    if (trackLink) {
      copyToClipboard(trackMessage, trackLink, 'Track', enqueueSnackbar);
    } else {
      // Fallback to non-tracked link if generation fails
      const fallbackLink = `https://api.kip.audio/public/preview/tracks/${trackId}`;
      copyToClipboard(trackMessage, fallbackLink, 'Track', enqueueSnackbar);
    }
    setIsGenerating(false);
    onCloseModal();
  }

  async function onShareSet() {
    setIsGenerating(true);
    const setLink = await generateShareLink('set', setId, api);
    if (setLink) {
      copyToClipboard(setMessage, setLink, 'Set', enqueueSnackbar);
    } else {
      // Fallback to non-tracked link if generation fails
      const fallbackLink = `https://api.kip.audio/public/preview/sets/${setId}`;
      copyToClipboard(setMessage, fallbackLink, 'Set', enqueueSnackbar);
    }
    setIsGenerating(false);
    onCloseModal();
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={onCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Share the currently playing set or track?
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={onShareSet}
            startIcon={
              isGenerating ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <ContentCopy />
              )
            }
            variant="contained"
            disabled={isGenerating}
          >
            Share Set
          </Button>
          <Button
            onClick={onShareTrack}
            startIcon={
              isGenerating ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <ContentCopy />
              )
            }
            variant="outlined"
            disabled={isGenerating}
          >
            Share Track
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ShareModal.propTypes = {
  open: PropTypes.bool,
  onCloseModal: PropTypes.func,
  setId: PropTypes.number,
  setMessage: PropTypes.string,
  trackId: PropTypes.number,
  trackMessage: PropTypes.string,
};

export default ShareModal;
